import React from 'react'
import PropTypes from 'prop-types'
import { Container } from 'react-bootstrap'
import dynamic from 'next/dynamic'
import queryGraphql from '@shared/components/queryGraphql'
import { LIST_AUTHORS } from '@graphql/author/author.query'
import Error from '@shared/components/error'
import Layout from '@shared/components/layout'
import { GET_SEO_DATA } from '@graphql/article/article.query'
import { checkRedirectionStatus, handleApiError } from '@shared-submodule/utils'

const AuthorList = dynamic(() => import('@shared/components/author'))

function Authors({ authorList, seoData }) {
  return (
    <Layout
      data={{
        oSeo: {
          ...seoData?.getSeoData,
          sTitle: 'Authors',
          sDescription:
            'Catch the latest Sports News Headlines of the day, Sports Breaking News Today, Latest Indian Cricket News, Cricket News Headlines, Live Cricket Match Today, Trending News, Cricket Events and Cricket Matches'
        }
      }}>
      <Container>
        <div className="d-flex flex-column gap-3 pt-4">
          <div className="d-flex flex-column gap-2">
            <h1 className="mb-1">{'Authors'}</h1>
            <p className="text-muted">
              {
                'This team collaborate to create interesting and informative content for cricket enthusiasts. They cover a wide range of topics, from news and analysis to feature articles that explore the history and culture of the sport. Their goal is to engage and entertain fans while also promoting the sport to a wider audience.'
              }
            </p>
          </div>
          <AuthorList list={authorList?.listAuthors} />
        </div>
      </Container>
    </Layout>
  )
}

export async function getServerSideProps({ res, resolvedUrl }) {
  try {
    res.setHeader('Cache-Control', 'public, max-age=600')

    const { allRoutes } = await import('@shared-submodule/sm-constants/allRoutes')
    const { data: seoData } = await queryGraphql(GET_SEO_DATA, { input: { sSlug: allRoutes.authors?.slice(1) } })
    // Check Redirection
    const { redirectStatus, eCode, returnObj, props } = checkRedirectionStatus(seoData?.getSeoData)
    if (redirectStatus && props) {
      res.statusCode = eCode
      return { props }
    } else if (redirectStatus) return returnObj
    const { data: authorList } = await queryGraphql(LIST_AUTHORS, {
      input: {
        nLimit: 8,
        nSkip: 1
      }
    })
    return {
      props: {
        authorList,
        seoData
      }
    }
  } catch (e) {
    res.setHeader('Cache-Control', 'no-cache')
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}

Authors.propTypes = {
  authorList: PropTypes.object,
  seoData: PropTypes.object
}

export default Error(Authors)
// export default Authors
